import React, { Component, useState, useEffect, useCallback } from "react";
import { Form, Input, Button, Spin, Select, DatePicker, Upload, Checkbox, Card, Modal } from "antd";import { LeftOutlined, UploadOutlined, CalendarOutlined, DownOutlined, UpOutlined, LoadingOutlined } from "@ant-design/icons";
import { useForm } from "react-hooks-helper";
import { useHistory } from "react-router-dom";
import './first-fields.css';
import { RESTExecutor, withDomains } from "../../lib/domain";
import Loader from "react-spinners/MoonLoader";
import ImgCrop from 'antd-img-crop';
import axios from "axios";
import { BASE_API_URL } from "../../config";
import { NepaliDatePicker } from "../../components/nepali_date_picker";
import moment from "moment";
import { calendarFunctions } from "../../components/nepali_date_picker/helper_bs";

const { Option } = Select;

const industries = [
  "Accounting & Auditing Firms",
  "Advertising Agencies",
  "Agricultural Commodity Traders",
  "Agro Farms & Nurseries",
  "Agro Input Suppliers",
  "Automotive Parts & Accessories",
  "Catering & Event Services",
  "Cement, Bricks & Construction Materials",
  "Civil Construction Contractors",
  "Clothing & Fashion Stores",
  "Cosmetics & Beauty Products",
  "Courier & Delivery Services",
  "Diagnostic Centers",
  "Digital Marketing Firms",
  "Digital Products & Subscriptions",
  "Electronics & Mobile Stores",
  "Event Management Companies",
  "Fast Food & Bakery",
  "Film, Music & Video Production",
  "FMCG Distributors",
  "Food & Beverage Manufacturing",
  "Furniture & Wood Products",
  "Gaming & Animation Studios",
  "Garment & Textile Industry",
  "General Trading",
  "Grocery & Departmental Stores",
  "Handicrafts & Traditional Goods",
  "Hardware & Construction Supplies",
  "Hospitals & Clinics",
  "Hotels, Resorts & Guest Houses",
  "Import & Export Businesses",
  "Interior Designers",
  "IT & Software Services",
  "Legal Consultancy",
  "Marketplace Sellers",
  "Medical & Pharmacy Stores",
  "Metal & Engineering Works",
  "News & Online Media",
  "Online Retail Stores",
  "Pharmacies",
  "Plastic & Packaging Industry",
  "Poultry & Dairy Farms",
  "Printing Press",
  "Real Estate Brokers",
  "Real Estate Developers",
  "Restaurants & Cafes",
  "Schools & Colleges",
  "Soap, Detergent & Chemical Production",
  "Stationery & Bookshops",
  "Tea & Coffee Production",
  "Training Institutes",
  "Travel & Tours",
  "Trucking & Freight Services",
  "Tuition Centers",
  "Vehicle Rentals",
  "Other",
];

const vatOptions = [
  "Yes",
  "No"
];

const customStyles = `
  /* Responsive styles for mobile devices */
  @media (max-width: 768px) {
    .mobile-container {
      padding: 20px 16px !important;
    }

    .mobile-card {
      padding: 24px 16px !important;
      margin: 0 !important;
    }

    .mobile-header {
      padding-right: 0 !important;
      margin-bottom: 24px !important;
    }

    .mobile-form-content {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }

    .mobile-row {
      flex-direction: column !important;
      gap: 20px !important;
    }

    .mobile-logo-container {
      width: 100% !important;
      max-width: 300px;
      margin: 0 auto !important;
    }

    .mobile-logo-upload {
      height: 210px !important;
      min-height: 180px !important;
      padding: 16px !important;
    }

    .mobile-logo-preview {
      height: 80px !important;
      margin-bottom: 12px !important;
    }

    .mobile-phone-pan-row {
      flex-direction: column !important;
      gap: 20px !important;
    }

    .desktop-logo-container {
      display: none !important;
    }

    .mobile-logo-container {
      display: flex !important;
    }
  }

  /* Desktop styles - hide mobile logo container */
  @media (min-width: 769px) {
    .mobile-logo-container {
      display: none !important;
    }
  }

  /* Override CSS variable that's causing 50px height */
  :root {
    --basic-input-height: 40px !important;
  }

  /* Animation styles for expandable sections */
  .expandable-section {
    overflow: hidden;
    transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out;
  }

  .expandable-section.collapsed {
    max-height: 0;
    opacity: 0;
  }

  .expandable-section.expanded {
    max-height: 1000px;
    opacity: 1;
  }

  .expandable-content {
    padding-top: 16px;
    transition: padding 0.3s ease-in-out;
  }

  .expandable-section.collapsed .expandable-content {
    padding-top: 0;
  }

  /* Toggle button animations */
  .toggle-button {
    transition: all 0.3s ease-in-out;
  }

  .toggle-button:hover {
    background-color: #f0f6ff;
    transform: translateY(-1px);
  }

  .toggle-icon {
    transition: transform 0.3s ease-in-out;
  }

  .toggle-icon.rotated {
    transform: rotate(180deg);
  }

  /* Form styling to match register.js with consistent 40px height */
  .ant-form-item-label > label {
    color: #636972 !important;
    font-size: 12px !important;
    font-family: 'Inter' !important;
    font-weight: 500 !important;
    margin-bottom: 4px !important;
  }

  .ant-input {
    background: var(--field-bg-color, #FFFFFF) !important;
    border: 1px solid #E0E5EB !important;
    border-radius: 6px !important;
    height: 40px !important;
    min-height: 40px !important;
    max-height: 40px !important;
    font-size: 12px !important;
    font-family: 'Inter' !important;
    color: #343C46 !important;
    padding: 8px 16px !important;
    line-height: 1.2 !important;
  }

  .ant-input-affix-wrapper {
    background: var(--field-bg-color, #FFFFFF) !important;
    border: 1px solid #E0E5EB !important;
    border-radius: 6px !important;
    height: 40px !important;
    min-height: 40px !important;
    max-height: 40px !important;
  }

  .ant-input-affix-wrapper:hover {
    border-color: #40a9ff !important;
  }

  .ant-input-affix-wrapper-focused {
    border-color: #40a9ff !important;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
  }

  .ant-input:hover {
    border-color: #40a9ff !important;
  }

  .ant-input:focus {
    border-color: #40a9ff !important;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
    outline: none !important;
  }

  .ant-input::placeholder {
    color: #BFC3C9 !important;
  }

  .ant-select {
    height: 40px !important;
    min-height: 40px !important;
    max-height: 40px !important;
  }

  .ant-select .ant-select-selector {
    background: var(--field-bg-color, #FFFFFF) !important;
    border: 1px solid #E0E5EB !important;
    border-radius: 6px !important;
    height: 40px !important;
    min-height: 40px !important;
    max-height: 40px !important;
    font-size: 12px !important;
    font-family: 'Inter' !important;
    padding: 8px 16px !important;
    line-height: 1.2 !important;
  }

  .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
    border-color: #40a9ff !important;
  }

  .ant-select-focused .ant-select-selector {
    border-color: #40a9ff !important;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
    outline: none !important;
  }

  .ant-select-open .ant-select-selector {
    border-color: #40a9ff !important;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
  }

  .ant-select-selection-placeholder {
    color: #BFC3C9 !important;
    line-height: 24px !important;
  }

  .ant-select-selection-item {
    color: #343C46 !important;
    line-height: 24px !important;
  }

  .ant-picker {
    background: var(--field-bg-color, #FFFFFF) !important;
    border: 1px solid #E0E5EB !important;
    border-radius: 6px !important;
    height: 40px !important;
    min-height: 40px !important;
    max-height: 40px !important;
    width: 100% !important;
    padding: 8px 16px !important;
  }

  .ant-picker:hover {
    border-color: #40a9ff !important;
  }

  .ant-picker:focus,
  .ant-picker-focused {
    border-color: #40a9ff !important;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
    outline: none !important;
  }

  .ant-picker-input > input {
    font-size: 12px !important;
    font-family: 'Inter' !important;
    color: #343C46 !important;
    line-height: 1.2 !important;
  }

  .ant-picker-input > input::placeholder {
    color: #BFC3C9 !important;
  }

  .ant-checkbox-wrapper {
    font-size: 12px !important;
    font-family: 'Inter' !important;
    color: #636972 !important;
    margin: 0 !important;
    padding: 0 !important;
    line-height: 18px !important;
  }

  .ant-checkbox {
    margin: 0 !important;
    padding: 0 !important;
  }

  /* Specific styles for promo code section */
  .promo-code-container {
    width: 100% !important;
  }
  
  .promo-code-row {
    display: flex !important;
    width: 100% !important;
    gap: 16px !important;
  }
  
  .promo-code-input-container {
    flex: 1 1 0 !important;
    min-width: 0 !important;
    width: 100% !important;
  }
  
  .promo-code-button-container {
    flex-shrink: 0 !important;
    width: 126px !important;
  }
  
  @media (max-width: 768px) {
    .promo-code-row {
      flex-direction: column !important;
    }
    
    .promo-code-input-container {
      width: 100% !important;
    }
    
    .promo-code-button-container {
      width: 100% !important;
    }
  }

  .ant-checkbox + span {
    margin: 0 !important;
    padding: 0 !important;
  }

  .ant-form-item-explain-error {
    color: #E82E49 !important;
    font-size: 12px !important;
    font-family: 'Inter' !important;
  }

  /* Fix industry field alignment and responsiveness */
  .ant-select-selector {
    align-items: center !important;
    display: flex !important;
  }
  
  .ant-select-selection-search {
    align-items: center !important;
    display: flex !important;
  }
  
  .ant-select-selection-search-input {
    vertical-align: middle !important;
    line-height: normal !important;
  }
  
  .ant-select-selection-placeholder {
    align-items: center !important;
    display: flex !important;
    line-height: normal !important;
  }

  .ant-form-item {
    margin-bottom: 4px !important;
  }

  .ant-form-item-control {
    min-height: auto !important;
  }

  /* Custom spacing for form sections to match logo height */
  .form-section-spacing {
    gap: 16px !important;
  }

  .logo-height-match {
    height: 210px !important;
    justify-content: space-between !important;
  }

  /* Custom Nepali Date Picker styling to match other form fields */
  .custom-nepali-datepicker-wrapper {
    transition: border-color 0.3s, box-shadow 0.3s;
  }

  .custom-nepali-datepicker-wrapper:hover {
    border-color: #40a9ff !important;
  }

  .custom-nepali-datepicker-wrapper:focus-within {
    border-color: #40a9ff !important;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
  }

  /* Ensure the inner input has no conflicting styles */
  .custom-nepali-datepicker-wrapper .ant-input {
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    padding: 0 !important;
    outline: none !important;
  }

  .custom-nepali-datepicker-wrapper .ant-input:focus {
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    outline: none !important;
  }

  /* Nepali Date Picker: single border, white background, 40px height */
  .rl-nepali-datepicker-neutral {
    background: #FFFFFF !important;
    border: 1px solid #E0E5EB !important;
    border-radius: 6px !important;
    height: 40px !important;
    min-height: 40px !important;
    max-height: 40px !important;
    display: flex !important;
    align-items: center !important;
    padding: 0 12px !important;
    transition: border-color 0.3s, box-shadow 0.3s !important;
  }

  .rl-nepali-datepicker-neutral:hover {
    border-color: #40a9ff !important;
  }

  .rl-nepali-datepicker-neutral:focus-within {
    border-color: #40a9ff !important;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
  }

  .rl-nepali-datepicker-neutral input,
  .rl-nepali-datepicker-neutral .ant-input {
    background: transparent !important;
    border: none !important;
    height: 100% !important;
    outline: none !important;
    box-shadow: none !important;
    padding: 0 !important;
  }

  .rl-nepali-datepicker-neutral .ant-input:focus {
    border: none !important;
    box-shadow: none !important;
  }

  /* Custom slug input wrapper to match hover/focus effects */
  .slug-input-wrapper {
    --slug-outline-color: #E0E5EB;
    background: var(--field-bg-color, #FFFFFF) !important;
    border-radius: 6px !important;
  }

  .slug-input-wrapper:hover:not([data-error="true"]) {
    --slug-outline-color: #40a9ff;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
  }

  .slug-input-wrapper:focus-within:not([data-error="true"]) {
    --slug-outline-color: #40a9ff;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
  }
`;

const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }
    const listener = () => setMatches(media.matches);
    window.addEventListener("resize", listener);
    return () => window.removeEventListener("resize", listener);
  }, [matches, query]);

  return matches;
};

const VerifyReferralCode = ({ isLoading, errorMessage, successMessage, isApplied }) => {
  return (
    <div>
      {isLoading && !errorMessage && !successMessage && (
        <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
          <p style={{ margin: 0, color: '#636972', fontSize: 12, fontFamily: 'Inter' }}>Validating referral code</p>
          <Spin size="small" />
        </div>
      )}

      {!isLoading && errorMessage && (
        <p style={{ margin: 0, color: 'var(--Error, #E82E49)', fontSize: 12, fontFamily: 'Inter', textAlign: "left" }}>
          {errorMessage}
        </p>
      )}
      {!isLoading && successMessage && (
        <p style={{ margin: 0, color: isApplied ? '#22C55E' : '#143E9F', fontSize: 12, fontFamily: 'Inter', textAlign: "left" }}>
          {successMessage}
        </p>
      )}
    </div>
  );
};

const VerifyNamespace = ({ isLoading, errorMessage, successMessage }) => {
  return (
    <div>
      {isLoading && !errorMessage && !successMessage && (
        <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
          <p style={{ margin: 0, color: '#636972', fontSize: 12, fontFamily: 'Inter' }}>Checking duplicate slug</p>
          <Spin size="small" />
        </div>
      )}

      {!isLoading && errorMessage && (
        <p style={{ margin: 0, color: 'var(--Error, #E82E49)', fontSize: 12, fontFamily: 'Inter', textAlign: "left" }}>
          {errorMessage}
        </p>
      )}
      {!isLoading && successMessage && (
        <p style={{ margin: 0, color: '#22C55E', fontSize: 12, fontFamily: 'Inter', textAlign: "left" }}>
          {successMessage}
        </p>
      )}
    </div>
  );
};


const LogoUpload = ({ error, onFileChange, currentFile, uploading = false }) => {
  const [fileList, setFileList] = useState([]);
  const [previewUrl, setPreviewUrl] = useState(null);
  
  useEffect(() => {
    const fileInputs = document.querySelectorAll('.logo-upload-skip-tab input[type="file"]');
    fileInputs.forEach((el) => {
      try {
        el.setAttribute('tabindex', '-1');
      } catch (_) {}
    });
    
    const logoContainer = document.querySelector('.logo-upload-skip-tab');
    if (logoContainer) {
      const focusableElements = logoContainer.querySelectorAll('button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
      focusableElements.forEach((el) => {
        try {
          el.setAttribute('tabindex', '-1');
        } catch (_) {}
      });
    }
  }, []);

  useEffect(() => {
    const handleFocus = (e) => {
      if (e.target.closest('.logo-upload-skip-tab')) {
        e.preventDefault();
        e.target.blur();
        return false;
      }
    };

    const handleKeyDown = (e) => {
      if (e.key === 'Tab' && e.target.closest('.logo-upload-skip-tab')) {
        e.preventDefault();
        return false;
      }
    };

    document.addEventListener('focusin', handleFocus);
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('focusin', handleFocus);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif';
    if (!isJpgOrPng) {
      console.error('You can only upload JPG/PNG/GIF files!');
      return false;
    }
    
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      console.error('Image must be smaller than 5MB!');
      return false;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      setPreviewUrl(e.target.result);
    };
    reader.readAsDataURL(file);

    return true; 
  };

  const handleRemove = () => {
    setFileList([]);
    setPreviewUrl(null);
    if (onFileChange) {
      onFileChange(null);
    }
  };

  const uploadProps = {
    beforeUpload,
    fileList,
    onRemove: handleRemove,
    showUploadList: false,
    accept: '.jpg,.jpeg,.png,.gif',
    customRequest: ({ file, onSuccess, onError }) => {
      if (onFileChange) {
        onFileChange(file, onSuccess, onError);
      }
    },
  };

  return (
    <div 
      tabIndex={-1}
      style={{
        width: '140px',
        flex: '1 1 0',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: 8,
        display: 'flex',
        paddingBottom: useMediaQuery("(max-width: 768px)") ? '32px' : '16px',
      }}
    >
      <div style={{ color: '#636972', fontSize: 12, fontFamily: 'Inter', fontWeight: '500', wordWrap: 'break-word' }}>
        Company Logo
      </div>
      
      <div tabIndex={-1}>
        <ImgCrop 
          rotate 
          aspect={1} 
          quality={0.8}
          modalTitle="Crop Logo"
          modalOk="Crop"
          modalCancel="Cancel"
        >
        <Upload {...uploadProps} disabled={uploading} tabIndex={-1} className="logo-upload-skip-tab" style={{ pointerEvents: 'auto' }}>
          <div style={{
            alignSelf: 'stretch',
            flex: '1 1 0',
            paddingLeft: '20px',
            paddingRight: '20px',
            paddingTop: '16px',
            paddingBottom: '16px',
            background: '#FAFAFA',
            borderRadius: '8px',
            outline: `1px ${error ? 'var(--Error, #E82E49)' : '#AFB5BB'} dashed`,
            outlineOffset: '-0.50px',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'center',
            display: 'flex',
            cursor: uploading ? 'not-allowed' : 'pointer',
            opacity: uploading ? 0.6 : 1,
            transition: 'all 0.3s ease'
          }}>
          {previewUrl ? (
            <div style={{
              alignSelf: 'stretch',
              height: 93,
              background: '#FAFAFA',
              borderRadius: 8,
              outline: `1px ${error ? 'var(--Error, #E82E49)' : '#E0E5EB'} solid`,
              outlineOffset: '-1px',
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
              overflow: 'hidden',
              position: 'relative'
            }}>
              <img 
                src={previewUrl} 
                alt="Logo preview" 
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: 6
                }}
              />
              <div 
                tabIndex={-1}
                onClick={(e) => {
                  e.stopPropagation();
                  handleRemove();
                }}
                style={{
                  position: 'absolute',
                  top: 4,
                  right: 4,
                  width: 20,
                  height: 20,
                  borderRadius: '50%',
                  background: 'rgba(0,0,0,0.5)',
                  color: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  fontSize: 12,
                  fontWeight: 'bold'
                }}
              >
                ×
              </div>
            </div>
          ) : (
            <div style={{
              alignSelf: 'stretch',
              height: 93,
              background: '#FAFAFA',
              borderRadius: 8,
              outline: `1px ${error ? 'var(--Error, #E82E49)' : '#E0E5EB'} solid`,
              outlineOffset: '-1px',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 8,
              display: 'inline-flex'
            }}>
              {uploading ? (
                <Spin indicator={<LoadingOutlined style={{ fontSize: 20, color: "#143E9F" }} spin />} />
              ) : (
                <UploadOutlined style={{ fontSize: "20px", color: "#91979F" }} />
              )}
            </div>
          )}
          
          <div style={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start', gap: 2, display: 'flex' }}>
            <div style={{ color: '#636972', fontSize: 12, fontFamily: 'Inter', fontWeight: '500', wordWrap: 'break-word' }}>
              {uploading ? 'Uploading...' : previewUrl ? 'Change logo' : 'Upload logo here'}
            </div>
            {!uploading && (
              <div style={{ color: '#BFC3C9', fontSize: 10, fontFamily: 'Inter', fontWeight: '400', wordWrap: 'break-word' }}>
                Min 300x300px<br />Maximum 5MB<br />JPG, PNG or GIF
              </div>
            )}
          </div>
        </div>
      </Upload>
        </ImgCrop>
      </div>
      
      {error && (
        <div style={{ alignSelf: 'stretch', color: 'var(--Error, #E82E49)', fontSize: 12, fontFamily: 'Inter', fontWeight: '400', wordWrap: 'break-word' }}>
          {error}
        </div>
      )}
    </div>
  );
};

const First = ({ setForm, formData, extra, setExtra, navigation, domains, authenticator }) => {
  const { name, display_name, slug } = formData;
  const [duplicateError, setDuplicateError] = useState("");
  const [sucessMessage, setSuceessMessage] = useState("");
  const [slugValue, setSlug] = useState((slug || "").toLowerCase());
  const showMoreInfo = extra.showMoreInfo;
  const setShowMoreInfo = (value) => setExtra(prev => ({ ...prev, showMoreInfo: value }));
  const showPromoCode = extra.showPromoCode;
  const setShowPromoCode = (value) => setExtra(prev => ({ ...prev, showPromoCode: value }));
  const termsAccepted = extra.termsAccepted;
  const setTermsAccepted = (value) => setExtra(prev => ({ ...prev, termsAccepted: value }));
  const logoFile = extra.logoFile;
  const setLogoFile = (value) => setExtra(prev => ({ ...prev, logoFile: value }));
  const logoError = extra.logoError;
  const setLogoError = (value) => setExtra(prev => ({ ...prev, logoError: value }));
  const logoUploading = extra.logoUploading;
  const setLogoUploading = (value) => setExtra(prev => ({ ...prev, logoUploading: value }));
  const uploadedLogoId = extra.uploadedLogoId;
  const setUploadedLogoId = (value) => setExtra(prev => ({ ...prev, uploadedLogoId: value }));
  
  const [referralCodeError, setReferralCodeError] = useState("");
  const [referralCodeSuccess, setReferralCodeSuccess] = useState("");
  const [referralCodeLoading, setReferralCodeLoading] = useState(false);
  const [isTermsModalVisible, setIsTermsModalVisible] = useState(false);
  const [isPolicyModalVisible, setIsPolicyModalVisible] = useState(false);
  const [referralCodeDebounceTimer, setReferralCodeDebounceTimer] = useState(null);
  const [referralCodeApplied, setReferralCodeApplied] = useState(false);
  const [isReferralCodeValid, setIsReferralCodeValid] = useState(false);
  const [filteredIndustries, setFilteredIndustries] = useState(industries);
  const [industrySearchValue, setIndustrySearchValue] = useState("");

  const getDefaultAccountingDate = () => {
    try {
      const bsYear = 2082;
      const bsMonth = 4;
      const bsDate = 1;
      
      const adDateObj = calendarFunctions.getAdDateObjectByBsDate(bsYear, bsMonth, bsDate);
      return `${adDateObj.adDate.toString().padStart(2, '0')}-${adDateObj.adMonth.toString().padStart(2, '0')}-${adDateObj.adYear}`;
    } catch (error) {
      console.error("Error calculating default BS date:", error);
      return moment().format("DD-MM-YYYY");
    }
  };

  const [defaultAccountingDate] = useState(getDefaultAccountingDate());
  const [selectedAccountingDate, setSelectedAccountingDate] = useState(
    extra.accounting_start_date && moment(extra.accounting_start_date).isValid() ? moment(extra.accounting_start_date).format("DD-MM-YYYY") : getDefaultAccountingDate()
  );

  const showTermsModal = (value) => {
    setIsTermsModalVisible(value);
  };

  const showPolicyModal = (value) => {
    setIsPolicyModalVisible(value);
  };

  const isMobile = useMediaQuery("(max-width: 768px)");

  const [debounceTimer, setDebounceTimer] = useState(null);

  const validateAndSanitizeText = (text, maxLength = 100) => {
    if (!text) return text;
    return text.replace(/[<>"\\/{}[\];%&$]/g, '').substring(0, maxLength).trim();
  };

  const validateOrganizationName = (name) => {
    if (!name || name.trim().length === 0) return false;
    const validPattern = /^[a-zA-Z0-9\s\-_.&(),]+$/;
    return validPattern.test(name.trim()) && name.trim().length >= 2 && name.trim().length <= 100;
  };

  const validateEmail = (email) => {
    if (!email) return true; 
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email) && !email.includes('+') && !email.includes('=');
  };

  const validatePhoneNumber = (phone) => {
    if (!phone) return true; 
    const phonePattern = /^\d{7,15}$/;
    return phonePattern.test(phone);
  };

  const validatePanNumber = (pan) => {
    if (!pan) return true; 
    const panPattern = /^\d{9}$/;
    return panPattern.test(pan);
  };

  const validateWebsite = (website) => {
    if (!website) return true; 
    const urlPattern = /^(https?:\/\/)?(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})(\/.*)?$/;
    return urlPattern.test(website);
  };

  const handleOrganizationNameChange = (e) => {
    const value = validateAndSanitizeText(e.target.value, 100);
    setForm({ target: { name: 'name', value } });
  };

  const handleAddressChange = (e) => {
    const value = validateAndSanitizeText(e.target.value, 200);
    setForm({ target: { name: 'address', value } });
  };

  const handleEmailChange = (e) => {
    let value = e.target.value;
    value = value.replace(/[+=]/g, '');
    value = validateAndSanitizeText(value, 100);
    setForm({ target: { name: 'email', value } });
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    setForm({ target: { name: 'phone', value } });
  };

  const handlePanChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    setForm({ target: { name: 'panNumber', value } });
  };

  const handleWebsiteChange = (e) => {
    let value = e.target.value;
    value = value.replace(/[\s<>"'{}[\]\\]/g, '');
    setForm({ target: { name: 'website', value } });
  };

  const handlePromoCodeChange = (e) => {
    const value = e.target.value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
    setForm({ target: { name: 'promoCode', value } });
    
    setReferralCodeApplied(false);
    setIsReferralCodeValid(false);
    setReferralCodeSuccess("");
    setReferralCodeError("");
    
  };

  const handleIndustryChange = (value) => {
    setForm({ target: { name: 'industry', value } });
  };

  const handleIndustrySearch = (searchValue) => {
    setIndustrySearchValue(searchValue);
    
    if (!searchValue || searchValue.trim() === "") {
      setFilteredIndustries(industries);
      return;
    }
    
    const searchTerm = searchValue.toLowerCase().trim();
    const filtered = industries.filter(industry => 
      industry.toLowerCase().includes(searchTerm)
    );
    
    if (filtered.length === 0) {
      setFilteredIndustries(["Other"]);
    } else {
      setFilteredIndustries(filtered);
    }
  };

  const handleApplyReferralCode = () => {
    const currentCode = formData.promoCode;
    
    if (!currentCode) {
      setReferralCodeError("Please enter a referral code first.");
      return;
    }
    
    if (currentCode.length < 3) {
      setReferralCodeError("Referral code must be at least 3 characters long.");
      return;
    }
    
    if (isReferralCodeValid && currentCode) {
      setReferralCodeApplied(true);
      setReferralCodeSuccess("Referral code applied successfully! You'll receive the discount on checkout.");
    } else {
      setReferralCodeLoading(true);
      setReferralCodeError("");
      setReferralCodeSuccess("");
      console.log("Manually validating referral code:", currentCode);
      validateReferralCode.execute({ referral_code: currentCode });
    }
  };

  const handleLogoChange = (file, onSuccess, onError) => {
    if (!file) {
      setLogoFile(null);
      setLogoError("");
      setUploadedLogoId(null);
      setForm({ target: { name: 'logo', value: null } });
      return;
    }

    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif';
    if (!isJpgOrPng) {
      setLogoError('You can only upload JPG/PNG/GIF files!');
      if (onError) onError(new Error('Invalid file type'));
      return;
    }
    
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      setLogoError('Image must be smaller than 5MB!');
      if (onError) onError(new Error('File too large'));
      return;
    }

    const img = new Image();
    img.onload = function() {
      if (this.width < 300 || this.height < 300) {
        setLogoError('Image must be at least 300x300px!');
        if (onError) onError(new Error('Image too small'));
        return;
      }
      
      setLogoError("");
      setLogoFile(file);
      uploadLogo(file, onSuccess, onError);
    };
    
    img.onerror = function() {
      setLogoError('Invalid image file!');
      if (onError) onError(new Error('Invalid image'));
    };
    
    img.src = URL.createObjectURL(file);
  };

  const uploadLogo = async (file, onSuccess, onError) => {
    setLogoUploading(true);
    setLogoError("");
    
    console.log("Starting logo upload for file:", file.name, file.size, file.type);
    console.log("Available domains:", domains);
    console.log("fileUpload domain:", domains?.fileUpload);
    
    try {
      const accessToken = authenticator?.getTokens()?.access_token;
      if (!accessToken) {
        throw new Error('Authentication token not available');
      }

      const config = {
        headers: {
          Accept: "binary/octet-stream",
          "content-type": "multipart/form-data",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      
      const generateUrlResponse = await axios.post(
        `${BASE_API_URL}/generate-upload-url`,
        { 
          collection: "NamespaceProfile"
        },
        config
      );

      console.log("Generated upload URL response:", generateUrlResponse.data);

      const uploadConfig = {
        headers: {
          "Content-Type": file.type,
        },
      };

      const uploadResponse = await axios.put(
        generateUrlResponse.data.data.url,
        file,
        uploadConfig
      );

      console.log("File upload completed successfully");

      setLogoUploading(false);
      const logoId = generateUrlResponse.data.data.key;
      console.log("Extracted logo ID:", logoId);
      
      setUploadedLogoId(logoId);
      setForm({ target: { name: 'logo', value: logoId } });
      
      if (onSuccess) {
        onSuccess({
          url: generateUrlResponse.data.data.url,
          id: logoId,
          response: generateUrlResponse.data
        });
      }

    } catch (error) {
      console.log("Logo upload error:", error);
      setLogoUploading(false);
      
      let errorMessage = 'Upload failed';
      if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.response?.data?.error_message) {
        errorMessage = error.response.data.error_message;
      } else if (error.message) {
        errorMessage = error.message;
      }
      
      setLogoError(errorMessage);
      setForm({ target: { name: 'logo', value: null } });
      
      if (onError) {
        onError(new Error(errorMessage));
      }
    }
  };

  const checkDuplicate = RESTExecutor.list()
    .config({
      label: "slug_check",
    })
    .callbacks(
      (success) => {
        setSuceessMessage(
          `Congratulations! The workspace name ${slugValue} is available. Click on the Next button to proceed.`
        );
        setDuplicateError("");
      },
      (error) => {
        console.log({ error }, "hello");
        setSuceessMessage("");
        setDuplicateError(error?.error_message);
      }
    )
    .connect(domains.register);

  const validateReferralCode = RESTExecutor.post()
    .config({
      label: "validate_referral_code",
    })
    .callbacks(
      (success) => {
        setReferralCodeError("");
        setReferralCodeLoading(false);
        setIsReferralCodeValid(true);
        
        if (!referralCodeApplied) {
          setReferralCodeApplied(true);
          setReferralCodeSuccess("Referral code applied successfully! You'll receive the discount on checkout.");
        } else {
          setReferralCodeSuccess("Referral code is valid! Click Apply to use this code.");
        }
      },
      (error) => {
        console.log({ error }, "referral code validation error");
        setReferralCodeSuccess("");
        setReferralCodeError(error?.error_message || "Invalid referral code");
        setReferralCodeLoading(false);
        setIsReferralCodeValid(false);
        setReferralCodeApplied(false);
      }
    )
    .connect(domains.user);

  const [form] = Form.useForm();
  const { next, previous } = navigation;
  const history = useHistory();

  const debouncedCheckSlug = useCallback((slugValue) => {
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }

    const timer = setTimeout(() => {
      if (slugValue.length >= 5) {
        checkDuplicate.config({ params: { slug: slugValue } }).execute();
      } else {
        setDuplicateError("");
        setSuceessMessage("");
      }
    }, 800); 

    setDebounceTimer(timer);
  }, [debounceTimer, checkDuplicate]);

  const debouncedValidateReferralCode = useCallback((referralCode) => {
    if (referralCodeDebounceTimer) {
      clearTimeout(referralCodeDebounceTimer);
    }

    const timer = setTimeout(() => {
      if (referralCode && referralCode.length >= 3) {
        setReferralCodeLoading(true);
        setReferralCodeError("");
        setReferralCodeSuccess("");
        console.log("Validating referral code:", referralCode);
        validateReferralCode.execute({ referral_code: referralCode });
      } else {
        setReferralCodeError("");
        setReferralCodeSuccess("");
        setReferralCodeLoading(false);
      }
    }, 800); 

    setReferralCodeDebounceTimer(timer);
  }, [referralCodeDebounceTimer, validateReferralCode]);

  const handleOrgSlugChange = (e) => {
    let value = e.target.value;
    value = value.toLowerCase().replace(/[^a-z0-9]/g, '');
    
    setSlug(value);
    setForm({ target: { name: 'slug', value } });
    
    if (form) {
      form.setFieldsValue({ slug: value });
    }
    
    setDuplicateError("");
    setSuceessMessage("");
    
    debouncedCheckSlug(value);
  };

  useEffect(() => {
    return () => {
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }
    };
  }, [debounceTimer]);

  useEffect(() => {
    return () => {
      if (referralCodeDebounceTimer) {
        clearTimeout(referralCodeDebounceTimer);
      }
    };
  }, [referralCodeDebounceTimer]);

  const formatAccountingDate = (date) => {
    return date ? moment(date).format("DD-MM-YYYY") : getDefaultAccountingDate();
  };

  useEffect(() => {
    const formValues = {
      name: formData.name || '',
      industry: formData.industry || '',
      email: formData.email || '',
      phone: formData.phone || '',
      address: formData.address || '',
      panNumber: formData.panNumber || '',
      website: formData.website || '',
      accountingDate: formatAccountingDate(extra.accounting_start_date),
      vatRegistered: extra.vat_registered ? "Yes" : "No",
      promoCode: formData.promoCode || '',
      slug: (formData.slug || '').toLowerCase(), 
    };
    
    const lowerSlug = (formData.slug || '').toLowerCase();
    setSlug(lowerSlug);
    
    if (formData.slug && formData.slug !== lowerSlug) {
      setForm({ target: { name: 'slug', value: lowerSlug } });
    }
    
    setSelectedAccountingDate(formatAccountingDate(extra.accounting_start_date));
    
    if (form) {
      form.setFieldsValue(formValues);
    }
  }, [
    formData.name,
    formData.industry,
    formData.email,
    formData.phone,
    formData.address,
    formData.panNumber,
    formData.website,
    formData.slug,
    formData.promoCode,
    extra.accounting_start_date,
    extra.vat_registered,
    form
  ]);

  const isFormValid = () => {
    if (!formData.name || !validateOrganizationName(formData.name)) {
      return false;
    }
    
    if (!formData.industry) {
      return false;
    }
    
    if (!formData.accountingDate) {
      return false;
    }
    
    if (!formData.vatRegistered) {
      return false;
    }
    
    if (!formData.slug || formData.slug.length < 5) {
      return false;
    }
    
    if (duplicateError) {
      return false;
    }
    
    if (!termsAccepted) {
      return false;
    }
    
    if (formData.email && !validateEmail(formData.email)) {
      return false;
    }
    
    if (formData.phone && !validatePhoneNumber(formData.phone)) {
      return false;
    }
    
    if (formData.panNumber && !validatePanNumber(formData.panNumber)) {
      return false;
    }
    
    if (formData.website && !validateWebsite(formData.website)) {
      return false;
    }
    
    if (formData.promoCode) {
      if (!isReferralCodeValid || !referralCodeApplied) {
        return false;
      }
    }
    
    return true;
  };

  const onFinishFailed = (errorInfo) => {
    const errorFields = errorInfo.errorFields.map(field => field.name[0]);
    const optionalInfoFields = ['email', 'phone', 'panNumber', 'website'];
    const promoCodeFields = ['promoCode'];
    const hasOptionalInfoError = errorFields.some(field => optionalInfoFields.includes(field));
    const hasPromoCodeError = errorFields.some(field => promoCodeFields.includes(field));
    
    if (hasOptionalInfoError && !showMoreInfo) {
      setShowMoreInfo(true);
      setTimeout(() => {
        const firstErrorField = errorFields.find(field => optionalInfoFields.includes(field));
        const fieldElement = document.querySelector(`[name="${firstErrorField}"]`);
        if (fieldElement) {
          fieldElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(() => {
            fieldElement.focus();
          }, 100);
        }
      }, 300);
    } else if (hasPromoCodeError && !showPromoCode) {
      setShowPromoCode(true);
      setTimeout(() => {
        const promoField = document.querySelector('[name="promoCode"]');
        if (promoField) {
          promoField.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(() => {
            promoField.focus();
          }, 100);
        }
      }, 300);
    }
  };

  const onFinish = (values) => {
    if (!termsAccepted) {
      return;
    }

    if (duplicateError) {
      return;
    }

    if (values.name && !validateOrganizationName(values.name)) {
      form.setFields([
        {
          name: 'name',
          errors: ['Please enter a valid organization name (2-100 characters, letters, numbers, and basic punctuation only).'],
        },
      ]);
      return;
    }

    if (values.email && !validateEmail(values.email)) {
      form.setFields([
        {
          name: 'email',
          errors: ['Please enter a valid email address.'],
        },
      ]);
      if (!showMoreInfo) {
        setShowMoreInfo(true);
        setTimeout(() => {
          const emailField = document.querySelector('[name="email"]');
          if (emailField) {
            emailField.scrollIntoView({ behavior: 'smooth', block: 'center' });
            emailField.focus();
          }
        }, 300);
      }
      return;
    }

    if (values.phone && !validatePhoneNumber(values.phone)) {
      form.setFields([
        {
          name: 'phone',
          errors: ['Please enter a valid phone number (7-15 digits only).'],
        },
      ]);
      if (!showMoreInfo) {
        setShowMoreInfo(true);
        setTimeout(() => {
          const phoneField = document.querySelector('[name="phone"]');
          if (phoneField) {
            phoneField.scrollIntoView({ behavior: 'smooth', block: 'center' });
            phoneField.focus();
          }
        }, 300);
      }
      return;
    }

    if (values.panNumber && !validatePanNumber(values.panNumber)) {
      form.setFields([
        {
          name: 'panNumber',
          errors: ['Please enter a valid PAN number (9 digits only).'],
        },
      ]);
      if (!showMoreInfo) {
        setShowMoreInfo(true);
        setTimeout(() => {
          const panField = document.querySelector('[name="panNumber"]');
          if (panField) {
            panField.scrollIntoView({ behavior: 'smooth', block: 'center' });
            panField.focus();
          }
        }, 300);
      }
      return;
    }

    if (values.website && !validateWebsite(values.website)) {
      form.setFields([
        {
          name: 'website',
          errors: ['Please enter a valid website URL (e.g., domain.com, https://domain.com, or subdomain.domain.com).'],
        },
      ]);
      if (!showMoreInfo) {
        setShowMoreInfo(true);
        setTimeout(() => {
          const websiteField = document.querySelector('[name="website"]');
          if (websiteField) {
            websiteField.scrollIntoView({ behavior: 'smooth', block: 'center' });
            websiteField.focus();
          }
        }, 300);
      }
      return;
    }

    if (values.promoCode && (!isReferralCodeValid || !referralCodeApplied)) {
      form.setFields([
        {
          name: 'promoCode',
          errors: ['Please ensure your referral code is valid and applied by clicking the Apply button.'],
        },
      ]);
      if (!showPromoCode) {
        setShowPromoCode(true);
        setTimeout(() => {
          const promoField = document.querySelector('[name="promoCode"]');
          if (promoField) {
            promoField.scrollIntoView({ behavior: 'smooth', block: 'center' });
            promoField.focus();
          }
        }, 300);
      }
      return;
    }

    if (values.promoCode && referralCodeLoading) {
      form.setFields([
        {
          name: 'promoCode',
          errors: ['Please wait while we validate your referral code.'],
        },
      ]);
      if (!showPromoCode) {
        setShowPromoCode(true);
        setTimeout(() => {
          const promoField = document.querySelector('[name="promoCode"]');
          if (promoField) {
            promoField.scrollIntoView({ behavior: 'smooth', block: 'center' });
            promoField.focus();
          }
        }, 300);
      }
      return;
    }

    const sanitizedValues = {
      ...values,
      name: values.name ? validateAndSanitizeText(values.name, 100) : '',
      address: values.address ? validateAndSanitizeText(values.address, 200) : '',
      email: values.email ? validateAndSanitizeText(values.email, 100) : '',
      website: values.website ? values.website.trim() : '',
      promoCode: values.promoCode ? values.promoCode.trim().toUpperCase() : '',
      accountingDate: values.accountingDate ? moment(values.accountingDate, "DD-MM-YYYY").format("YYYY-MM-DD") : '',
      slug: values.slug ? values.slug.toLowerCase() : '', 
    };

    Object.keys(sanitizedValues).forEach(key => {
      setForm({ target: { name: key, value: sanitizedValues[key] } });
    });

    next();
  };

  return (
    <div 
      className="mobile-container"
      style={{
        backgroundColor: "#EEF2F7", 
        minHeight: "100vh", 
        padding: isMobile ? "20px 16px" : "96px 192px",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start"
      }}
    >
      <style>{customStyles}</style>
      
      <Card
        className="mobile-card"
        style={{
          backgroundColor: "#FAFAFA",
          borderRadius: "16px",
          boxShadow: "0px 28px 62px rgba(37, 78, 207, 0.03)",
          padding: isMobile ? "24px 16px" : "40px 32px",
          width: "100%",
          maxWidth: "900px",
          margin: "0 auto",
          border: "none"
        }}
      >
        <div 
          className="mobile-header"
          style={{ 
            display: "flex", 
            alignItems: "flex-start", 
            justifyContent: "space-between",
            marginBottom: "32px",
            paddingRight: isMobile ? "0" : "40px",
            paddingLeft: isMobile ? "0" : "40px"
          }}
        >
          
          <div style={{
            flex: '1 1 0',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
            gap: 2,
            display: 'inline-flex'
          }}>
            <div style={{
              alignSelf: 'stretch',
              color: '#343C46',
              fontSize: isMobile ? 20 : 24,
              fontFamily: 'Inter',
              fontWeight: '700',
              wordWrap: 'break-word'
            }}>
              Set Up Your Organization
            </div>
            <div style={{
              color: '#636972',
              fontSize: 12,
              fontFamily: 'Inter',
              fontWeight: '400',
              wordWrap: 'break-word'
            }}>
              You can now set up your first organization
            </div>
          </div>
          <div style={{ width: 70, height: 40, position: 'relative' }}>
            <img 
              src="images/logo.svg" 
              style={{ 
                width: "100%",
                height: "100%",
                objectFit: "contain"
              }} 
              alt="Tigg Logo"
            />
          </div>
        </div>

        <div 
          className="mobile-form-content"
          style={{
            paddingLeft: isMobile ? "0" : "48px",
            paddingRight: isMobile ? "0" : "48px"
          }}
        >
          <Form
            form={form}
            name="setup_organization"
            layout="vertical"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            initialValues={{
              name: name,
              slug: (slug || '').toLowerCase(),
              industry: formData.industry,
              email: formData.email,
              phone: formData.phone,
              address: formData.address,
              panNumber: formData.panNumber,
              website: formData.website,
              accountingDate: selectedAccountingDate,
              vatRegistered: extra.vat_registered ? "Yes" : "No",
              promoCode: formData.promoCode,
            }}
          >
            <div 
              className="mobile-row"
              style={{
                display: "flex", 
                gap: isMobile ? "16px" : "32px", 
                marginBottom: "24px",
                flexDirection: isMobile ? 'column' : 'row'
              }}
            >
              <div 
                className="logo-height-match"
                style={{
                  flex: '1 1 0',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  display: 'inline-flex'
                }}
              >
                <Form.Item
                  label="Organization Name"
                  name="name"
                  labelCol={{ span: 24 }}
                  style={{ alignSelf: 'stretch', marginBottom: 0 }}
                  rules={[
                    {
                      required: true,
                      message: "Please enter Organization Name.",
                    },
                    {
                      min: 2,
                      message: "Organization name must be at least 2 characters long.",
                    },
                    {
                      max: 100,
                      message: "Organization name cannot exceed 100 characters.",
                    },
                    {
                      pattern: /^[a-zA-Z0-9\s\-_.&(),]+$/,
                      message: "Organization name contains invalid characters.",
                    },
                  ]}
                >
                  <Input
                    placeholder="Organization Name"
                    onChange={handleOrganizationNameChange}
                    maxLength={100}
                  />
                </Form.Item>

                <Form.Item
                  label="Industry"
                  name="industry"
                  labelCol={{ span: 24 }}
                  style={{ alignSelf: 'stretch', width:'100%', marginBottom: 0 }}
                  rules={[
                    {
                      required: true,
                      message: "Please select an Industry.",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select Industry"
                    style={{ width: '100%' }}
                    showSearch
                    optionFilterProp="children"
                    onChange={handleIndustryChange}
                    onSearch={handleIndustrySearch}
                    filterOption={false}
                    allowClear
                    searchValue={industrySearchValue}
                    onClear={() => {
                      setIndustrySearchValue("");
                      setFilteredIndustries(industries);
                    }}
                    notFoundContent={null}
                  >
                    {filteredIndustries.map((industry, index) => (
                      <Option key={index} value={industry}>
                        {industry}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item
                  label="Organization Address"
                  name="address"
                  labelCol={{ span: 24 }}
                  style={{ alignSelf: 'stretch', marginBottom: 0 }}
                  rules={[
                    {
                      max: 200,
                      message: "Address cannot exceed 200 characters.",
                    },
                  ]}
                >
                  <Input
                    placeholder="Organization Address"
                    onChange={handleAddressChange}
                    maxLength={200}
                  />
                </Form.Item>
              </div>

              <div 
                style={{ 
                  width: "133px", 
                  display: "flex", 
                  flexDirection: "column"
                }}
                className="desktop-logo-container"
              >
                <LogoUpload 
                  error={logoError}
                  onFileChange={handleLogoChange}
                  currentFile={logoFile}
                  uploading={logoUploading}
                />
              </div>
            </div>



            <div 
              className="mobile-row"
              style={{
                display: "flex", 
                gap: "16px", 
                marginBottom: "24px",
                flexDirection: isMobile ? 'column' : 'row',
                width: '100%'
              }}
            >
              <Form.Item
                label="Accounting Start Date"
                name="accountingDate"
                labelCol={{ span: 24 }}
                style={{ flex: '1 1 0', width: isMobile ? '100%' : '50%', marginBottom: 0 }}
                rules={[
                  {
                    required: true,
                    message: "Please select accounting start date.",
                  },
                ]}
              >
                <NepaliDatePicker
                  placeholder="DD-MM-YYYY (BS)"
                  calendarType="BS"
                  style={{ width: '100%' }}
                  className="rl-nepali-datepicker-neutral"
                  value={selectedAccountingDate}
                  onChange={(value) => {
                    console.log("Accounting date selected:", value);
                    const finalValue = value || getDefaultAccountingDate();
                    setSelectedAccountingDate(finalValue);
                    form.setFieldsValue({ accountingDate: finalValue });
                    const momentDate = moment(finalValue, "DD-MM-YYYY");
                    setExtra(prev => ({ ...prev, accounting_start_date: momentDate }));
                  }}
                />
              </Form.Item>

              <Form.Item
                label="Registered with VAT?"
                name="vatRegistered"
                labelCol={{ span: 24 }}
                style={{ flex: '1 1 0', width: isMobile ? '100%' : '50%', marginBottom: 0 }}
                rules={[
                  {
                    required: true,
                    message: "Please select an option.",
                  },
                ]}
              >
                <Select
                  placeholder="Select Option"
                  style={{ width: '100%' }}
                  onChange={(value) => {
                    const vatRegistered = value === "Yes";
                    setExtra(prev => ({ ...prev, vat_registered: vatRegistered }));
                  }}
                >
                  {vatOptions.map((option, index) => (
                    <Option key={index} value={option}>
                      {option}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>

            <div style={{ marginBottom: "24px" }}>
              <Form.Item
                label="Workspace Name"
                name="slug"
                labelCol={{ span: 24 }}
                style={{ width: '100%', marginBottom: 0 }}
                validateStatus={duplicateError ? "error" : ""}
                rules={[
                  {
                    required: true,
                    message: "Please enter workspace name.",
                  },
                  {
                    min: 5,
                    message: "Workspace name must be atleast 5 characters long.",
                  },
                ]}
              >
                <div
                  className="slug-input-wrapper"
                  data-error={duplicateError ? 'true' : 'false'}
                  style={{
                    width: '100%',
                    background: '#FFFFFF',
                    borderRadius: 6,
                    outline: '1px var(--slug-outline-color) solid',
                    outlineOffset: '-1px',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    display: 'inline-flex',
                    ...(duplicateError ? { ['--slug-outline-color']: 'var(--Error, #E82E49)' } : {})
                  }}
                >
                  <div style={{
                    flex: '1 1 0',
                    height: 40,
                    padding: 16,
                    borderRadius: 6,
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    gap: 8,
                    display: 'flex'
                  }}>
                    <input
                      type="text"
                      style={{
                        border: 'none',
                        background: 'transparent',
                        outline: 'none',
                        width: '100%',
                        color: slugValue ? 'var(--Text-primary, #343C46)' : '#BFC3C9',
                        fontSize: 12,
                        fontFamily: 'Inter',
                        fontWeight: '400',
                        textTransform: 'lowercase'
                      }}
                      placeholder="yourcompany"
                      value={slugValue.toLowerCase()}
                      onKeyPress={(event) => {
                        if (!/[a-zA-Z0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      onChange={handleOrgSlugChange}
                    />
                  </div>
                  <div style={{
                    width: 131,
                    height: 40,
                    padding: 16,
                    background: '#FFFFFF',
                    borderTopRightRadius: 6,
                    borderBottomRightRadius: 6,
                    outline: '1px var(--slug-outline-color) solid',
                    outlineOffset: '-1px',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    gap: 8,
                    display: 'flex'
                  }}>
                    <div style={{
                      opacity: 0.70,
                      color: '#343C46',
                      fontSize: 12,
                      fontFamily: 'Inter',
                      fontWeight: '500',
                      wordWrap: 'break-word'
                    }}>
                      .tigg.app
                    </div>
                  </div>
                </div>
              </Form.Item>
              <div style={{
                alignSelf: 'stretch',
                justifyContent: 'flex-start',
                alignItems: 'center',
                gap: 8,
                display: 'inline-flex'
              }}>
                <div style={{
                  color: '#636972',
                  fontSize: 12,
                  fontFamily: 'Inter',
                  fontWeight: '400',
                  wordWrap: 'break-word'
                }}>
                  This will be your organization's login URL
                </div>
              </div>
              <VerifyNamespace
                isLoading={checkDuplicate.response().fetching}
                errorMessage={duplicateError}
                successMessage={sucessMessage}
              />
            </div>

            <div style={{
              alignSelf: 'stretch',
              flexDirection: 'column',
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
              gap: 10,
              display: 'flex',
            }}>
              <div style={{ alignSelf: 'stretch', height: 0, outline: '1px #E0E5EB solid', outlineOffset: '-0.50px' }}></div>
              
              <div
                className="toggle-button"
                style={{
                  alignSelf: 'stretch',
                  height: 18,
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  display: 'inline-flex',
                  cursor: 'pointer',
                  padding: '12px',
                  paddingTop: '18px',
                  paddingBottom: '18px',
                  borderRadius: 6,
                }}
                onClick={() => setShowMoreInfo(!showMoreInfo)}
              >
                <div style={{
                  color: 'var(--Main-blue, #143E9F)',
                  fontSize: 12,
                  fontFamily: 'Inter',
                  fontWeight: '600',
                  lineHeight: '18px',
                  wordWrap: 'break-word',
                }}>
                  Add more organization info
                </div>
                <DownOutlined 
                  className={`toggle-icon ${showMoreInfo ? 'rotated' : ''}`}
                  style={{ 
                    color: "var(--Main-blue, #143E9F)", 
                    fontSize: "10px"
                  }} 
                />
              </div>

              <div className={`expandable-section ${showMoreInfo ? 'expanded' : 'collapsed'}`} style={{ width: '100%' }}>
                <div className="expandable-content">
                  <div style={{
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    gap: 16,
                    display: 'flex',
                    width: '100%',
                  }}>
                    <Form.Item
                      label="Email"
                      name="email"
                      labelCol={{ span: 24 }}
                      style={{ alignSelf: 'stretch', marginBottom: 0 }}
                      rules={[
                        {
                          type: 'email',
                          message: 'Please enter a valid email address.',
                        },
                        {
                          validator: (_, value) => {
                            if (!value) return Promise.resolve();
                            if (value.includes('+') || value.includes('=')) {
                              return Promise.reject(new Error('Email cannot contain + or = characters.'));
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                      <Input
                        placeholder="contact@gmail.com"
                        onChange={handleEmailChange}
                        onFocus={() => setShowMoreInfo(true)}
                        maxLength={100}
                      />
                    </Form.Item>

                    <div 
                      className="mobile-phone-pan-row"
                      style={{
                        display: "flex", 
                        gap: "16px",
                        flexDirection: isMobile ? 'column' : 'row',
                        width: '100%',
                        marginBottom: "16px"
                      }}
                    >
                      <Form.Item
                        label="Organization Phone Number"
                        name="phone"
                        labelCol={{ span: 24 }}
                        style={{ flex: '1 1 0', width: isMobile ? '100%' : '50%', marginBottom: 0 }}
                        rules={[
                          {
                            pattern: /^\d{7,15}$/,
                            message: "Please enter a valid phone number (7-15 digits only).",
                          },
                        ]}
                      >
                        <Input
                          placeholder="9841234567"
                          onChange={handlePhoneChange}
                          onFocus={() => setShowMoreInfo(true)}
                          maxLength={15}
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </Form.Item>

                      <Form.Item
                        label="PAN Number"
                        name="panNumber"
                        labelCol={{ span: 24 }}
                        style={{ flex: '1 1 0', width: isMobile ? '100%' : '50%', marginBottom: 0 }}
                        rules={[
                          {
                            pattern: /^\d{9}$/,
                            message: "Please enter a valid PAN number (9 digits only).",
                          },
                        ]}
                      >
                        <Input
                          placeholder="123456789"
                          onChange={handlePanChange}
                          onFocus={() => setShowMoreInfo(true)}
                          maxLength={12}
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </Form.Item>
                    </div>

                    <Form.Item
                      label="Website"
                      name="website"
                      labelCol={{ span: 24 }}
                      style={{ alignSelf: 'stretch', marginBottom: 0 }}
                      rules={[
                        {
                          pattern: /^(https?:\/\/)?(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})(\/.*)?$/,
                          message: "Please enter a valid website URL (e.g., domain.com, https://domain.com, or subdomain.domain.com).",
                        },
                      ]}
                    >
                      <Input
                        placeholder="yourcompany.com"
                        onChange={handleWebsiteChange}
                        onFocus={() => setShowMoreInfo(true)}
                        maxLength={200}
                      />
                    </Form.Item>
                    <div 
                      className="mobile-logo-container"
                      style={{ 
                        width: "133px", 
                        display: isMobile ? "flex" : "none", 
                        flexDirection: "column", 
                        marginBottom: "16px",
                        margin: "0 auto"
                      }}
                    >
                      <div tabIndex={-1}>
                        <LogoUpload 
                          error={logoError}
                          onFileChange={handleLogoChange}
                          currentFile={logoFile}
                          uploading={logoUploading}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div style={{
              alignSelf: 'stretch',
              flexDirection: 'column',
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
              gap: 10,
              display: 'flex',
              marginTop: 16
            }}>
              <div style={{ alignSelf: 'stretch', height: 0, outline: '1px #E0E5EB solid', outlineOffset: '-0.50px' }}></div>
              
              <div
                className="toggle-button"
                style={{
                  alignSelf: 'stretch',
                  height: 18,
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  display: 'inline-flex',
                  cursor: 'pointer',
                  padding: '12px',
                  paddingTop: '18px',
                  paddingBottom: '18px',
                  borderRadius: 6,
                }}
                onClick={() => setShowPromoCode(!showPromoCode)}
              >
                <div style={{
                  color: 'var(--Main-blue, #143E9F)',
                  fontSize: 12,
                  fontFamily: 'Inter',
                  fontWeight: '600',
                  lineHeight: '18px',
                  wordWrap: 'break-word'
                }}>
                  Have a referral code?
                </div>
                <DownOutlined 
                  className={`toggle-icon ${showPromoCode ? 'rotated' : ''}`}
                  style={{ 
                    color: "var(--Main-blue, #143E9F)", 
                    fontSize: "10px"
                  }} 
                />
              </div>

              <div className={`expandable-section ${showPromoCode ? 'expanded' : 'collapsed'} promo-code-container`}>
                <div className="expandable-content promo-code-container">
                  <div className="promo-code-container" style={{
                    alignSelf: 'stretch',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    gap: 16,
                    display: 'flex',
                    flexDirection: 'column'
                  }}>
                    <div className={`promo-code-row ${isMobile ? 'mobile' : ''}`}>
                      <div className="promo-code-input-container">
                        <Form.Item
                          name="promoCode"
                          style={{ 
                            marginBottom: 0,
                            width: '100%'
                          }}
                        >
                          <Input
                            placeholder="Enter Referral Code"
                            value={formData.promoCode || ""}
                            onChange={handlePromoCodeChange}
                            style={{ 
                              width: '100%',
                              textTransform: 'uppercase'
                            }}
                            onFocus={() => setShowPromoCode(true)}
                            maxLength={20}
                            onKeyPress={(e) => {
                              if (!/[a-zA-Z0-9]/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                          />
                        </Form.Item>
                      </div>
                      
                      <div className="promo-code-button-container">
                        <Button
                          onClick={handleApplyReferralCode}
                          disabled={referralCodeApplied || referralCodeLoading || !formData.promoCode}
                          style={{
                            width: '100%',
                            height: 40,
                            background: (!referralCodeApplied && !referralCodeLoading && formData.promoCode) ? 'var(--Main-blue, #143E9F)' : 'transparent',
                            boxShadow: '0px 8px 24px -8px rgba(20, 62, 159, 0.16)',
                            borderRadius: 6,
                            border: '1px solid #E0E5EB',
                            color: (!referralCodeApplied && !referralCodeLoading && formData.promoCode) ? 'white' : '#343C46',
                            fontSize: '12px',
                            fontFamily: 'Inter',
                            fontWeight: '500',
                            cursor: (!referralCodeApplied && !referralCodeLoading && formData.promoCode) ? 'pointer' : 'not-allowed'
                          }}
                        >
                          {referralCodeLoading ? 'Applying...' : referralCodeApplied ? 'Applied' : 'Apply'}
                        </Button>
                      </div>
                    </div>
                    
                    {formData.promoCode && (
                      <div style={{ 
                        width: '100%'
                      }}>
                        <VerifyReferralCode 
                          isLoading={referralCodeLoading}
                          errorMessage={referralCodeError}
                          successMessage={referralCodeSuccess}
                          isApplied={referralCodeApplied}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div style={{
              alignSelf: 'stretch',
              flexDirection: 'column',
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
              gap: '12px',
              display: 'flex',
              marginTop: 0,
              marginBottom: 0,
              paddingTop: 0,
              paddingBottom: 0
            }}>
              <Form.Item
                name="termsAccepted"
                valuePropName="checked"
                rules={[
                  {
                    validator: (_, value) =>
                      value ? Promise.resolve() : Promise.reject(new Error('Please accept the terms and conditions')),
                  },
                ]}
              >
                <Checkbox
                  checked={termsAccepted}
                  onChange={(e) => setTermsAccepted(e.target.checked)}
                  style={{
                    margin: 0,
                    padding: 0,
                    gap: '12px',
                    lineHeight: 1
                  }}
                >
                  <span style={{ color: '#636972', fontSize: 12, fontFamily: 'Inter', fontWeight: '400', lineHeight: 1, wordWrap: 'break-word' }}>
                    {' '}I agree to Tigg's{' '}
                  </span>
                  <span
                    style={{ color: 'var(--Main-blue, #143E9F)', fontSize: 12, fontFamily: 'Inter', fontWeight: '600', lineHeight: 1, wordWrap: 'break-word', cursor: 'pointer', textDecoration: 'underline' }}
                    onClick={(e) => { e.preventDefault(); showTermsModal(true); }}
                  >
                    Terms of Service
                  </span>
                  <span style={{ color: '#636972', fontSize: 12, fontFamily: 'Inter', fontWeight: '400', lineHeight: 1, wordWrap: 'break-word' }}>
                    {' '}and{' '}
                  </span>
                  <span
                    style={{ color: 'var(--Main-blue, #143E9F)', fontSize: 12, fontFamily: 'Inter', fontWeight: '600', lineHeight: 1, wordWrap: 'break-word', cursor: 'pointer', textDecoration: 'underline' }}
                    onClick={(e) => { e.preventDefault(); showPolicyModal(true); }}
                  >
                    Privacy Policy
                  </span>
                </Checkbox>
              </Form.Item>

              <div
                className="mobile-buttons"
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  gap: isMobile ? '12px' : '16px',
                  flexDirection: isMobile ? 'column' : 'row',
                  width: '100%'
                }}
              >
                <Button
                  icon={<LeftOutlined />}
                  size="large"
                  onClick={() => history.push('/')}
                  style={{
                    borderRadius: 6,
                    minWidth: isMobile ? '100%' : 120,
                    fontWeight: 600,
                    fontFamily: 'Inter',
                    height: 48,
                    fontSize: "12px",
                  }}
                >
                  Back
                </Button>
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={!termsAccepted || duplicateError}
                  style={{
                    height: 48,
                    minWidth: isMobile ? '100%' : 200,
                    background: termsAccepted && !duplicateError ? 'var(--Main-blue, #143E9F)' : '#CBD0D6',
                    boxShadow: termsAccepted && !duplicateError ? '0px 8px 24px -8px rgba(20, 62, 159, 0.16)' : 'none',
                    borderRadius: 6,
                    border: 'none',
                    color: 'white',
                    fontSize: '12px',
                    fontFamily: 'Inter',
                    fontWeight: '600',
                    lineHeight: '18px',
                    cursor: termsAccepted && !duplicateError ? 'pointer' : 'not-allowed',
                    margin: 0,
                    padding: '0 16px'
                  }}
                >
                  Next
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </Card>

      <Modal
        className="terms-modal"
        id="terms-modal"
        maskClosable={false}
        title="Terms of Service"
        visible={isTermsModalVisible}
        onCancel={() => {
          showTermsModal(false);
        }}
        bodyStyle={{
          height: 500,
          backgroundColor: "#EEF2F7",
          margin: "20px",
          overflow: "auto",
        }}
        footer={[<></>]}
      >
        <p>
          B.I.C. Technology Private Limited and/or its affiliates ("BIC") are
          willing to provide access to the Service to you as the company or
          entity using it (referred to as "Customer") if you agree to all the
          terms in this Agreement. By accepting this Agreement on behalf of an
          entity or organization, you confirm you have the authority to bind
          that entity or organization to these terms.
        </p>
        <p>
          Both Customer and BIC are referred to as a "Party" individually and
          "Parties" together.
        </p>

        <p>
          Both Customer and BIC are referred to as a "Party" individually and
          "Parties" together.
        </p>

        <p>
          Please read this Agreement carefully. By agreeing electronically or
          using the Service, you accept the terms. If you do not agree, do not
          proceed with the acceptance or use of the Service.
        </p>

        <h1>Description of Service</h1>
        <p>
          BIC provides a cloud-based accounting platform designed to streamline
          financial management for businesses. Our Services include, but are not
          limited to, Accounting and Bookkeeping, Invoicing and Billing,
          Inventory Management, Bank Reconciliation, Document Management, CRM,
          Expenses Management, Financial Reporting Etc.
        </p>

        <p>
          Please note that access to certain features may be limited based on
          your subscription plan. You will only be able to use the features
          included in the subscription you have purchased. The scope of our
          Services may evolve, and any significant changes will be communicated
          in accordance with our Terms of Service.
        </p>

        <h1>Registration Data and Privacy</h1>
        <p>
          In order to access some of the services, you will be required to use
          an account and password that can be obtained by completing our online
          registration form, which requests certain information and data ("Sign
          Up"), and maintaining and updating your Registration Data as required.
          By registering, you agree that all information provided in the
          Registration Data is true and accurate and that you will maintain and
          update this information as required in order to keep it current,
          complete, and accurate.
        </p>

        <h1>Organization Accounts and Administrators</h1>
        <p>
          When you sign up for an account for your organization, the initiating
          user automatically becomes the administrator. The administrator will
          have the right to configure the Services based on your requirements
          and manage end users in your organization account. If your
          organization account is created and configured on your behalf by a
          third party, it is likely that such a third party has assumed an
          administrator role for your organization. Make sure that you enter
          into a suitable agreement with such a third party specifying such
          party's roles and restrictions as an administrator of your
          organization account.
        </p>

        <p>You are responsible for:</p>

        <ul>
          <li>
            ensuring confidentiality of your organization account password,
          </li>
          <li>
            appointing competent individuals as administrators for managing your
            organization account, and
          </li>
          <li>
            ensuring that all activities that occur in connection with your
            organization account comply with this Agreement.
          </li>
        </ul>

        <p>
          You understand that BIC is not responsible for account administration
          and internal management of the Services for you. You are responsible
          for taking the necessary steps for ensuring that your organization
          does not lose control of the administrator accounts.
        </p>

        <p>
          Changes to the administrator role can only be made by BIC. To request
          a change, the current administrator must email support@tiggapp.com
          from the email address registered at the time of account creation. If
          this email address is unavailable, we may request additional legal
          documents to verify the organization's ownership before making the
          change.
        </p>

        <h1>Computerized Billing Compliance</h1>
        <p>
          If you subscribe to our Computerised Billing feature, both parties
          agree to comply with all requirements set by the Inland Revenue
          Department of Nepal, including adhering to the terms, conditions, and
          any updates issued by the department. Failure by either party to meet
          these requirements may result in fines and penalties. Each party
          agrees to indemnify the other for any losses or damages incurred due
          to the other party's non-compliance. For more details, please refer to
          the Electronic Billing Procedure, 2074 (विद्युतीय बीजक सम्बन्धी
          कार्यविधि, २०७४).
        </p>

        <h1>Subscription and Renewals</h1>
        <ul>
          <li>
            The customer shall pay a subscription fee in advance without any
            deduction or set-off (except for Tax withholding if applicable)
            INVOICE will be generated only after payment of the subscription fee
            in advance.
          </li>
          <li>
            Without prejudice to Customer's rights set out elsewhere in this
            Agreement, all subscription fees are non-refundable and payable in
            advance.
          </li>
          <li>
            From time to time, we may change the price of any Service or charge
            for use of Services that are currently available free of charge. Any
            increase in charges will not apply until the expiry of your
            then-current billing cycle. You will not be charged for using any
            Service unless you have opted for a paid subscription plan.
          </li>
          <li>
            In order to provide continuous service, we automatically renew all
            paid subscriptions for the Services on the date such subscriptions
            expire. Such renewals are for the same duration as the original
            subscription term (for example, a 1-year subscription will renew on
            a yearly basis). By entering into this Agreement, you acknowledge
            that your account will be subject to the above-described automatic
            renewals. In all cases, if you do not wish your account to renew
            automatically, please contact BIC'S support before the expiration of
            such a subscription.
          </li>
          <li>
            Except as otherwise stated in this section, you may cancel your paid
            subscription at any time during the term of such subscription or any
            renewal period by completely cancelling the account.
          </li>
          <li>
            In such a case, your subscription will terminate, and you will not
            receive any refund for any unused days of such subscription term.
          </li>
        </ul>

        <h1>Trademark</h1>
        <p>
          BIC, Tigg, the BIC logo, the Tigg logo, and the names and logos of
          individual Services are trademarks of B.I.C. Technology. You agree not
          to display or use these trademarks in any manner without prior
          permission from BIC.
        </p>
        <p>
          Our obligation to protect your Confidential Information will continue
          even after the termination of your use of our service. We will
          implement appropriate technical and organizational measures to
          safeguard your information against unauthorized access, loss, or
          theft.
        </p>
        <p>
          You also agree to keep any information we provide to you, which is
          marked as confidential or should reasonably be understood to be
          confidential, strictly confidential and to use it only for the
          purposes for which it was disclosed.
        </p>

        <h1>Confidential Information</h1>
        <p>
          We will not disclose your Confidential Information to any third party
          without your prior written consent, except as required by law or
          necessary for the provision of the Services. In such cases, we will
          make reasonable efforts to notify you in advance, unless prohibited by
          law.
        </p>

        <p>
          Our obligation to protect your Confidential Information will continue
          even after the termination of your use of our service. We will
          implement appropriate technical and organizational measures to
          safeguard your information against unauthorized access, loss, or
          theft.
        </p>

        <p>
          You also agree to keep any information we provide to you, which is
          marked as confidential or should reasonably be understood to be
          confidential, strictly confidential and to use it only for the
          purposes for which it was disclosed.
        </p>

        <h1>Data Security, Backup and Recovery</h1>
        <p>
          BIC will implement and maintain appropriate technical and
          organizational measures to protect Customer data from unauthorized
          access, cyber-attacks, and data breaches within its systems and
          infrastructure.
        </p>

        <p>
          BIC will maintain regular backups of Customer data to protect against
          data loss due to system failures, cyber-attacks, or other incidents.
          These backups will be used solely for restoration purposes in the
          event of a verified data loss.
        </p>

        <p>
          If BIC becomes aware of a confirmed or suspected data breach or
          unauthorized access affecting Customer data, BIC will notify the
          Customer without undue delay, including details of the incident,
          remedial actions taken, and expected resolution timelines.
        </p>

        <p>
          BIC's liability for any data loss, breach, or failure to restore data
          shall be subject to the Limitation of Liability clause set forth in
          this Agreement.
        </p>

        <h1>Data Ownership and Disclosure</h1>
        <p>
          You own all your business's private data, content, and information
          that you enter and use in connection with the Services. We do not
          claim any rights, proprietary or otherwise, over any data or
          information you may use or disclose in connection with Tigg. However,
          there may be circumstances where we are required to disclose data,
          such as:
        </p>

        <ul>
          <li>
            To comply with any legal, governmental or regulatory requirement;
          </li>
          <li>To comply with a court order.</li>
        </ul>

        <p>
          If we are required to disclose your data or information, we will use
          our best efforts to provide you with reasonable notice in the
          circumstances and if appropriate the right to challenge any such
          request.
        </p>
        <ol>
          <li>
            To comply with any legal, governmental or regulatory requirement;
          </li>
          <li>To comply with a court order.</li>
        </ol>
        <p>
          If we are required to disclose your data or information, we will use
          our best efforts to provide you with reasonable notice in the
          circumstances and if appropriate the right to challenge any such
          request.
        </p>

        <p>
          Tigg uses AI technologies to power features like document scanning and
          transaction suggestions. Some of these features rely on trusted
          third-party AI providers, and limited data may be securely shared with
          them solely to deliver the specific functionality. We do not use your
          data to train any AI models, and we only work with AI providers who
          explicitly confirm that they do not use user data for training their
          models. All data handling follows strict privacy and security
          standards.
        </p>

        <h1>Data Access and Retention Upon Non-Renewal or Termination</h1>
        <p>
          In the event of non-renewal or termination of services, B.I.C
          Technology will not be liable for any data loss incurred by the
          customer. Upon expiration of the subscription, B.I.C Technology will
          provide a grace period of at least one (1) month for customers to
          access and retrieve their data. After this period, B.I.C Technology is
          no longer responsible for maintaining or storing the customer's data,
          which may be permanently deleted.
        </p>

        <p>
          For terminated accounts, data will be deleted within 60 days of
          notifying the client. If the client cannot be reached, data will be
          automatically deleted after 120 days. Clients subject to IRD billing
          compliance will have their data deleted only after obtaining approval
          from relevant tax authorities. While customers can request data
          deletion on demand, this option is not available for IRD-compliant
          clients due to regulatory requirements. Additionally, B.I.C Technology
          offers a read-only subscription plan for clients who wish to continue
          accessing their data post-termination.
        </p>

        <h1>Force Majeure</h1>
        <p>
          Neither party should be held liable for a delay or failure in
          performance of the agreement for services caused by reason of any
          occurrence of unforeseen event beyond its reasonable control,
          including but not limited to, acts of God, natural disasters, power
          failures, server failures, third party service provider failures or
          service interruptions, embargo, labour disputes, lockouts and strikes,
          riots, war, floods, insurrections, legislative changes, and
          governmental actions. The party so affected by the unforeseen event
          shall be so excused on a day-to-day basis for the period of time equal
          to that of the underlying cause of delay.
        </p>

        <h1>Restriction on Use</h1>
        <p>
          You must use Tigg responsibly and in a way that does not harm,
          disrupt, or negatively impact other users. Use of automated tools,
          scripts, or any methods that interfere with the normal operation of
          Tigg or affect other users is strictly prohibited.
        </p>
        <p>
          We reserve the right to suspend or terminate your access without
          notice if we reasonably believe your actions compromise the trust,
          security, or functionality of the platform or its users. You also
          agree to be fully responsible for, and to cover, any damages, losses,
          or costs arising from your inappropriate use of Tigg.
        </p>

        <h1>Terms and Termination</h1>
        <p>
          This Agreement is effective as of the Effective Date and continues
          until the expiration of all subscription terms, unless terminated
          earlier as specified herein. You may choose to stop using the Software
          and terminate this Agreement at any time for any reason by providing
          written notice to BIC. However, you will not be entitled to a refund
          of any prepaid fees. If you have not yet paid all applicable fees for
          the current subscription term or related services period, any
          outstanding fees will become immediately due and payable.
        </p>

        <h1>Limitation of Liability</h1>
        <p>
          To the maximum extent permitted by law, Bic Technology shall not be
          liable for any indirect, incidental, special, consequential, or
          punitive damages, or any loss of profits or revenues, whether incurred
          directly or indirectly, or any loss of data, use, goodwill, or other
          intangible losses, resulting from your use of the Service.
        </p>

        <h1>Indemnification</h1>
        <p>
          Each party agrees to defend, indemnify, and hold the other party and
          its affiliates harmless from and against all liabilities, claims, and
          expenses, including attorney fees, arising out of or related to any
          misuse, negligence, or breach of obligations under this agreement by
          the indemnifying party.
        </p>

        <h1>End of Terms of Service</h1>

        <p>
          If you have any questions or concerns regarding this Agreement, please
          contact us at{" "}
          <a href="mailto:hello@tiggapp.com">hello@tiggapp.com.</a>
        </p>
      </Modal>

      <Modal
        className="policy-modal"
        id="policy-modal"
        maskClosable={false}
        title="Privacy Policy"
        visible={isPolicyModalVisible}
        onCancel={() => {
          showPolicyModal(false);
        }}
        bodyStyle={{
          height: 500,
          backgroundColor: "#EEF2F7",
          margin: "20px",
          overflow: "auto",
        }}
        footer={[<></>]}
      >
        <h1>Introduction:</h1>

        <p>
          This Privacy Policy covers the information we collect about you when
          you use our products or services, or otherwise interact with us.
        </p>

        <p>
          Our products and services are offered by{" "}
          <strong>B.I.C. Technology Private Limited</strong>
          <strong> </strong> (<strong>BIC</strong>" or "<strong>we</strong>"), a
          Nepali Company (Reg No.240710/077/078).
        </p>

        <p>This privacy policy applies to:</p>

        <ul>
          <li>tiggapp.com or tigg.app and its subdomains (the "Site");</li>
          <li>our mobile apps that incorporate this privacy policy; and</li>
          <li>
            products and services branded with the "TIGG" or "BIC" name
            ("Services").
          </li>
        </ul>

        <p>
          We treat your personal information with the same respect we want our
          own to be treated with—and when you deal with finances like we do,
          there's a lot of personal information involved. Here's a list of
          exactly what we collect.
        </p>

        <h3>What Information We Collect About You</h3>
        <p>
          We collect information about you when you provide it to us, when you
          use our Services, and when other sources provide it to us, as further
          described below.
        </p>
        <ol>
          <li>
            <strong>Account and Profile Information:</strong> When you sign up
            or update your profile on our platform, we gather details such as
            your name, email address, and any preferences you set. This helps us
            manage your account and tailor the services to your needs.
          </li>
          <li>
            <strong>Content You Provide Through Our Products:</strong> As you
            use our products, we collect any information you enter. We also
            track how you interact with our services to understand which
            features you use and how you use them.
          </li>
          <li>
            <strong>Content You Provide Through Our Websites:</strong>{" "}
            Information you submit through our websites, including forms or
            comments, is collected. This also includes data from our social
            media pages that we operate.
          </li>
          <li>
            <strong>Information from Support Channels:</strong> When you contact
            our customer support for assistance, we collect details about the
            issue you're facing and any relevant information you provide. This
            helps us address your concerns effectively.
          </li>
          <li>
            <strong>Payment Information:</strong> For transactions involving our
            paid services, we collect payment details like bank information and
            billing addresses to process payments securely.
          </li>
          <li>
            <strong>Device and Connection Information:</strong> We gather
            information about the devices you use to access our services,
            including details like your IP address, browser type, and operating
            system. This helps us ensure compatibility and troubleshoot any
            issues.
          </li>
          <li>
            <strong>Cookies and Tracking Technologies:</strong> We use cookies
            and similar technologies to remember your preferences and track your
            interactions with our services. This allows us to enhance your user
            experience and provide personalized content.
          </li>
          <li>
            <strong>Information from Other Sources:</strong> We may receive
            additional information from third parties, such as social media
            platforms or public databases. This helps us update our records and
            offer you more relevant services and advertisements.
          </li>
          <li>
            <strong>BIC's Partners:</strong> We collaborate with partners who
            assist with consulting, training, and marketing. We may receive
            information from them related to your interactions with our products
            or services.
          </li>
          <li>
            <strong>Other Partners:</strong> We also collect information from
            partners involved in advertising and market research. This data
            helps us understand your engagement with our services and
            advertisements.
          </li>
        </ol>

        <h3>How We Use Information We Collect</h3>
        <p>
          How we use the information we collect depends in part on which
          Services you use, how you use them, and any preferences you have
          communicated to us. Below are the specific purposes for which we use
          the information we collect about you.
        </p>
        <ol>
          <li>
            <strong>
              To Provide the Services and Personalize Your Experience:
            </strong>{" "}
            We use information about you to provide the Services to you,
            including to process transactions with you, authenticate you when
            you log in, provide customer support, and operate, maintain, and
            improve the Services.
          </li>
          <li>
            <strong>For Research and Development:</strong> We are always looking
            for ways to make our Services smarter, faster, secure, integrated,
            and useful. We use information and collective learnings (including
            feedback) about how people use our Services to troubleshoot, to
            identify trends, usage, activity patterns, and areas for integration
            and to improve our Services and to develop new products, features
            and technologies that benefit our users and the public. We also test
            and analyze certain new features with some users before rolling the
            feature out to all users.
          </li>
          <li>
            <strong>To Communicate with You About the Services:</strong> We use
            your contact information to send transactional communications via
            email and within the Services, including confirming your purchases,
            reminding you of subscription expirations, responding to your
            comments, questions and requests, providing customer support, and
            sending you technical notices, updates, security alerts, and
            administrative messages. We send you email notifications when you or
            others interact with you on the Services.
          </li>
          <li>
            <strong>
              To Market, Promote, and Drive Engagement with the Services:
            </strong>{" "}
            We use your contact information and information about how you use
            the Services to send promotional communications that may be of
            specific interest to you, including by email and by displaying BIC's
            ads on other companies' websites and applications.
          </li>
          <li>
            <strong>Customer Support:</strong> We use your information to
            resolve technical issues you encounter, to respond to your requests
            for assistance, to analyze crash information, and to repair and
            improve the Services. Where you give us express permission to do so,
            we share information with a third-party expert for the purpose of
            responding to support-related requests.
          </li>
          <li>
            <strong>For Safety and Security:</strong> We use information about
            you and your Service use to verify accounts and activity, to detect,
            prevent, and respond to potential or actual security incidents and
            to monitor and protect against other malicious, deceptive,
            fraudulent, or illegal activity.
          </li>
          <li>
            <strong>
              To Protect Our Legitimate Business Interests and Legal Rights:
            </strong>{" "}
            Where required by law or where we believe it is necessary to protect
            our legal rights, interests, and the interests of others, we use
            information about you in connection with legal claims, compliance,
            regulatory, and audit functions.
          </li>
        </ol>

        <h3>How We Share Information We Collect</h3>
        <p>
          We share information we collect about you in the ways discussed below.
          We are not in the business of selling information about you to
          advertisers or other third parties.
        </p>

        <h5>
          <strong>Sharing with Other Service Users</strong>
        </h5>
        <p>
          When you use the Services, we share certain information about you with
          other Service users.
        </p>
        <ul>
          <li>
            <strong>For Collaboration:</strong> You can create content, which
            may contain information about you, and grant permission to others to
            see, share, edit, copy, and download that content based on settings
            you or your administrator (if applicable) select.
          </li>
          <li>
            <strong>Managed Accounts and Administrators:</strong> If you're
            using our service as a general user in an organization, your
            information—such as your name, profile picture, and contact
            details—might be visible to the organization's administrator and
            other users within the same organization. If you're an administrator
            for an organization, we may share your contact information with
            current users to help manage service-related requests.
          </li>
        </ul>

        <h5>
          <strong>Sharing with third parties</strong>
        </h5>
        <p>
          We share information with third parties that help us operate, provide,
          improve, integrate, customize, support and market our Services.
        </p>

        <ul>
          <li>
            <strong>Service Providers:</strong> We work with third-party service
            providers to provide website and application development, hosting,
            maintenance, backup, storage, virtual infrastructure, payment
            processing, analysis and other services for us, which may require
            them to access or use information about you. If a service provider
            needs to access information about you to perform services on our
            behalf, they do so under close instruction from us, including
            appropriate security and confidentiality procedures designed to
            protect your information.
          </li>
          <li>
            <strong>Partners: </strong> We work with third parties who provide
            consulting, sales, support, and technical services to deliver and
            implement customer solutions around the Services. We may share your
            information with these third parties in connection with their
            services, such as to assist with billing and collections, to provide
            localized support, and to provide customizations. We may also share
            information with these third parties where you have agreed to that
            sharing.
          </li>
          <li>
            <strong>With your consent: </strong> We share information about you
            with third parties when you give us consent to do so. For example,
            we often display personal testimonials of satisfied customers on our
            public websites. With your consent, we may post your name alongside
            the testimonial.
          </li>
        </ul>

        <h3>How we store and secure information we collect</h3>
        <h5>Information storage and security</h5>
        <p>
          We use industry-standard technical and organizational measures to
          secure the information we store. While we implement safeguards
          designed to protect your information, no security system is
          impenetrable and due to the inherent nature of the Internet, we cannot
          guarantee that information, during transmission through the Internet
          or while stored on our systems or otherwise in our care, is absolutely
          safe from intrusion by others.
        </p>

        <h5>How long we keep information</h5>
        <p>
          How long we keep information we collect about you depends on the type
          of information, as described in further detail below. After such time,
          we will either delete or de-identify your information or, if this is
          not possible (for example, because the information has been stored in
          backup archives), then we will securely store your information and
          isolate it from any further use until deletion is possible.
        </p>

        <h3>Changes to our Privacy Policy</h3>
        <p>
          We may change this privacy policy from time to time. We will post any
          privacy policy changes on this page and, if the changes are
          significant, we will provide a more prominent notice by sending you an
          email notification. We encourage you to review our privacy policy
          whenever you use the Services to stay informed about our information
          practices and the ways you can help protect your privacy.
        </p>

        <p>
          If you disagree with any changes to this privacy policy, you will need
          to stop using the Services and deactivate your account(s), as outlined
          above.
        </p>

        <p>
          Your information is controlled by B.I.C. Technology Private Limited.
          If you have questions or concerns about how your information is
          handled, please direct your inquiry to B.I.C. Technology Private
          Limited, which we have appointed to be responsible for facilitating
          such inquiries.
        </p>

        <p>B.I.C. Technology Private Limited</p>
        <p>Thashikhel-14, Lalitpur</p>
        <p>
          E-Mail:
          <a href="mailto:hello@tiggapp.com?subject=Inquiries">
            hello@tiggapp.com
          </a>
        </p>
      </Modal>
    </div>
    
  );
  
};


export default withDomains(First, "register", "fileUpload", "user");
